








import { Vue, Component } from 'vue-property-decorator'
@Component({})
export default class NotFound extends Vue {
  href: string = ''
  mounted() {
    // 不显示参数
    this.href = window.location.href.split('?')[0]
  }
  handleBack() {
    const historyLength = window.history.length
    if (historyLength > 1) {
      this.$router.back()
    } else {
      ;(window as any).MgtvApi.closeWebView()
    }
  }
}
